import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {LocaleService} from "../../../../locale/locale.service";
import { NgOptimizedImage } from "@angular/common";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {ClaimsService} from "../../../../services/claims.service";

@Component({
  selector: 'app-data-is-correct',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule,
    NgOptimizedImage
],
  templateUrl: './data-is-correct.component.html',
  styleUrl: './data-is-correct.component.css'
})
export class DataIsCorrectComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  dataIsCorrect: boolean | null = null;
  showErrorMessage: boolean = false;
  checkboxControl: FormControl = new FormControl();

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.userHasConfirmedCorrectnessOfData) {
        this.dataIsCorrect = this.claimService.claimReport().userHasConfirmedCorrectnessOfData;
        this.checkboxControl = new FormControl(this.claimService.claimReport().userHasConfirmedCorrectnessOfData);
      }
    })
  }

  private evaluateShowError() {
    let rawValue = this.checkboxControl.getRawValue();
    this.showErrorMessage = rawValue !== true;
  }

  onCheckboxChange() {
    this.dataIsCorrect = !this.dataIsCorrect;
    this.checkboxControl.patchValue(this.dataIsCorrect);
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showErrorMessage) {
      this.claimService.updateClaimReport({userHasConfirmedCorrectnessOfData: true});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['data-is-correct']);
      });

    }
  }
}
